import { render, staticRenderFns } from "./epic-mychart.vue?vue&type=template&id=f4d1d5b4&scoped=true&"
import script from "./epic-mychart.vue?vue&type=script&lang=js&"
export * from "./epic-mychart.vue?vue&type=script&lang=js&"
import style0 from "./epic-mychart.vue?vue&type=style&index=0&id=f4d1d5b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d1d5b4",
  null
  
)

component.options.__file = "epic-mychart.vue"
export default component.exports